module.exports = __webpack_public_path__ + "img/garden_quadrado.66c9013b.png";